/**
 * Admin activity summary API client (SUPER_ADMIN only).
 */

import apiClient from '../../api/config/ApiClient';
import { API_ENDPOINTS } from '../../../config/api';

/**
 * Fetch product activity summary for a date range.
 * @param {{ from?: string, to?: string }} params - ISO dates YYYY-MM-DD
 * @returns {Promise<{ data: Object|null, error: string|null }>}
 */
export const getActivitySummary = async ({ from, to } = {}) => {
  try {
    const params = {};
    if (from) {
      params.from = from;
    }
    if (to) {
      params.to = to;
    }

    const data = await apiClient.get(API_ENDPOINTS.ADMIN.ACTIVITY_SUMMARY, { params });
    return { data, error: null };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 403) {
      return { data: null, error: 'forbidden' };
    }
    if (status === 401) {
      return { data: null, error: 'unauthorized' };
    }
    if (status === 429) {
      return { data: null, error: 'rate_limited' };
    }
    if (status === 400) {
      return {
        data: null,
        error: error?.response?.data?.message || error?.response?.data?.error || 'bad_request'
      };
    }
    return {
      data: null,
      error: error?.response?.data?.message || error?.message || 'unknown'
    };
  }
};

export const adminActivityService = {
  getActivitySummary
};

export default adminActivityService;
